module.exports = __webpack_public_path__ + "img/productBgImg20.26038490.png";